var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwake6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 156",
    style: {
      enableBackground: "new 0 0 156 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.8,1.1c5.8,0,10.5,4.7,10.5,10.5v132c0,5.8-4.7,10.5-10.5,10.5h-132c-5.8,0-10.5-4.7-10.5-10.5v-132 C1.3,5.8,6,1.1,11.8,1.1H143.8 M143.8-0.4h-132c-6.6,0-12,5.4-12,12v132c0,6.6,5.4,12,12,12h132c6.6,0,12-5.4,12-12v-132 C155.8,5,150.4-0.4,143.8-0.4L143.8-0.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78,145.7c-37.3,0-67.7-30.4-67.7-67.7S40.7,10.3,78,10.3s67.7,30.4,67.7,67.7S115.3,145.7,78,145.7z M78,15 c-34.7,0-63,28.3-63,63c0,34.7,28.3,63,63,63c34.7,0,63-28.3,63-63C141,43.3,112.7,15,78,15z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.5,
    cy: 112.8,
    rx: 24.3,
    ry: 11.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.9,
    cy: 67,
    rx: 6.8,
    ry: 7.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.5,
    cy: 67,
    rx: 6.8,
    ry: 7.5
  })), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16.6,
    y1: 41.9,
    x2: 2.3,
    y2: 25.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.9,
    y1: 24.7,
    x2: 19.7,
    y2: 5.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 123.2,
    y1: 21.7,
    x2: 132.4,
    y2: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 138,
    y1: 37.9,
    x2: 152.3,
    y2: 21.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwake6);
export default __webpack_public_path__ + "static/media/Awake6.e57b80e8f97eca36dcf1185fc714e8a3.svg";
export { ForwardRef as ReactComponent };